// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mmtees-head {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.mmtees-title {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 4px;
    color: var(--md-ink, #0f172a);
}

.mmtees-sub {
    margin: 0;
    color: var(--md-muted, #64748b);
    font-size: 14px;
}

.mmtees-head-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.mmtees-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.mmtees-card {
    background: #fff;
    border: 1px solid var(--md-line, #e2e8f0);
    border-radius: 12px;
    padding: 18px;
}

.mmtees-card-top {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    margin-bottom: 14px;
}

.mmtees-avatar {
    width: 48px;
    height: 48px;
    border-radius: 999px;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.mmtees-avatar.is-blue {
    background: #1d4ed8;
}

.mmtees-avatar.is-teal {
    background: #0f766e;
}

.mmtees-avatar.is-violet {
    background: #6d28d9;
}

.mmtees-avatar.is-amber {
    background: #b45309;
}

.mmtees-avatar.is-rose {
    background: #be123c;
}

.mmtees-name-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}

.mmtees-name {
    font-size: 16px;
    font-weight: 700;
    margin: 0;
    color: var(--md-ink, #0f172a);
}

.mmtees-pill {
    font-size: 11px;
    font-weight: 600;
    color: #15803d;
    background: #dcfce7;
    border-radius: 999px;
    padding: 2px 8px;
}

.mmtees-identity,
.mmtees-meta {
    font-size: 13px;
    color: var(--md-muted, #64748b);
    margin: 4px 0 0;
}

.mmtees-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
}

.mmtees-chip {
    font-size: 11px;
    background: #ecfdf5;
    color: #065f46;
    border-radius: 999px;
    padding: 2px 8px;
}

.mmtees-goals {
    background: #f1f5f9;
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 10px;
}

.mmtees-goals-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--md-muted, #64748b);
    margin: 0 0 4px;
}

.mmtees-goals-body {
    margin: 0;
    font-size: 13px;
    color: #334155;
}

.mmtees-stats {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 8px;
    margin: 14px 0;
    border-top: 1px solid #f1f5f9;
    border-bottom: 1px solid #f1f5f9;
    padding: 12px 0;
}

.mmtees-stats > div {
    text-align: center;
}

.mmtees-stat-value {
    display: block;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.2;
}

.mmtees-stat-value.is-blue {
    color: #1d4ed8;
}

.mmtees-stat-value.is-muted {
    color: #94a3b8;
}

.mmtees-stat-value.is-ink {
    color: #0f172a;
    font-size: 13px;
}

.mmtees-stat-label {
    display: block;
    font-size: 10px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--md-muted, #64748b);
    margin-top: 2px;
}

.mmtees-dod,
.mmtees-links {
    font-size: 12px;
    color: var(--md-muted, #64748b);
    margin: 0 0 10px;
    padding-left: 16px;
}

.mmtees-card-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

@media (max-width: 767px) {
    .mmtees-grid,
    .mmtees-stats {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/mentorship/mentorMentees.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,QAAQ;IACR,cAAc;IACd,6BAA6B;IAC7B,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI;;QAEI,0BAA0B;IAC9B;AACJ","sourcesContent":[".mmtees-head {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.mmtees-title {\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0 0 4px;\n    color: var(--md-ink, #0f172a);\n}\n\n.mmtees-sub {\n    margin: 0;\n    color: var(--md-muted, #64748b);\n    font-size: 14px;\n}\n\n.mmtees-head-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.mmtees-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n}\n\n.mmtees-card {\n    background: #fff;\n    border: 1px solid var(--md-line, #e2e8f0);\n    border-radius: 12px;\n    padding: 18px;\n}\n\n.mmtees-card-top {\n    display: flex;\n    gap: 12px;\n    align-items: flex-start;\n    margin-bottom: 14px;\n}\n\n.mmtees-avatar {\n    width: 48px;\n    height: 48px;\n    border-radius: 999px;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 700;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.mmtees-avatar.is-blue {\n    background: #1d4ed8;\n}\n\n.mmtees-avatar.is-teal {\n    background: #0f766e;\n}\n\n.mmtees-avatar.is-violet {\n    background: #6d28d9;\n}\n\n.mmtees-avatar.is-amber {\n    background: #b45309;\n}\n\n.mmtees-avatar.is-rose {\n    background: #be123c;\n}\n\n.mmtees-name-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n}\n\n.mmtees-name {\n    font-size: 16px;\n    font-weight: 700;\n    margin: 0;\n    color: var(--md-ink, #0f172a);\n}\n\n.mmtees-pill {\n    font-size: 11px;\n    font-weight: 600;\n    color: #15803d;\n    background: #dcfce7;\n    border-radius: 999px;\n    padding: 2px 8px;\n}\n\n.mmtees-identity,\n.mmtees-meta {\n    font-size: 13px;\n    color: var(--md-muted, #64748b);\n    margin: 4px 0 0;\n}\n\n.mmtees-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 8px;\n}\n\n.mmtees-chip {\n    font-size: 11px;\n    background: #ecfdf5;\n    color: #065f46;\n    border-radius: 999px;\n    padding: 2px 8px;\n}\n\n.mmtees-goals {\n    background: #f1f5f9;\n    border-radius: 10px;\n    padding: 12px 14px;\n    margin-bottom: 10px;\n}\n\n.mmtees-goals-label {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--md-muted, #64748b);\n    margin: 0 0 4px;\n}\n\n.mmtees-goals-body {\n    margin: 0;\n    font-size: 13px;\n    color: #334155;\n}\n\n.mmtees-stats {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 8px;\n    margin: 14px 0;\n    border-top: 1px solid #f1f5f9;\n    border-bottom: 1px solid #f1f5f9;\n    padding: 12px 0;\n}\n\n.mmtees-stats > div {\n    text-align: center;\n}\n\n.mmtees-stat-value {\n    display: block;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1.2;\n}\n\n.mmtees-stat-value.is-blue {\n    color: #1d4ed8;\n}\n\n.mmtees-stat-value.is-muted {\n    color: #94a3b8;\n}\n\n.mmtees-stat-value.is-ink {\n    color: #0f172a;\n    font-size: 13px;\n}\n\n.mmtees-stat-label {\n    display: block;\n    font-size: 10px;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: var(--md-muted, #64748b);\n    margin-top: 2px;\n}\n\n.mmtees-dod,\n.mmtees-links {\n    font-size: 12px;\n    color: var(--md-muted, #64748b);\n    margin: 0 0 10px;\n    padding-left: 16px;\n}\n\n.mmtees-card-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n@media (max-width: 767px) {\n    .mmtees-grid,\n    .mmtees-stats {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
